import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { installChunkLoadErrorRecovery } from './utils/chunkLoadErrorRecovery';
import './assets/scss/material-kit-react.scss?v=1.8.00';
import 'font-awesome/css/font-awesome.min.css';
import CssBaseline from "@mui/material/CssBaseline";
import {
    ThemeProvider,
    createTheme,
    StyledEngineProvider
} from "@mui/material/styles";
import { HelmetProvider } from 'react-helmet-async';
import { ensureAnalyticsInitialized } from './utils/analytics';

// Recover from stale-bundle ChunkLoadError (missing hashed chunk after a
// redeploy) before anything else can trigger a lazy import.
installChunkLoadErrorRecovery();

// GA4 initialization is deferred until analytics consent is granted.
ensureAnalyticsInitialized();
// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(initialState);

const theme = createTheme({
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontSize: "0.8rem"
          }
        }
      }
    }
  });

const app = (
    <HelmetProvider>
        <Provider store={store}>
            <BrowserRouter
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true,
                }}
            >
                <ThemeProvider theme={theme}>
                <CssBaseline />
                    <StyledEngineProvider injectFirst>
                        <App />
                    </StyledEngineProvider>
                </ThemeProvider>
            </BrowserRouter>
        </Provider>
    </HelmetProvider>
);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(app);

registerServiceWorker();
